import { createClient } from '@supabase/supabase-js'

// Use the actual project credentials from the connected Supabase project
const SUPABASE_URL = 'https://rwwybazgepsdbsoitgjn.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ3d3liYXpnZXBzZGJzb2l0Z2puIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ4OTA3NTYsImV4cCI6MjA3MDQ2Njc1Nn0.iuJFJkIAyZ648m_E28h4d2nsMevZzhA2rKpqziZsUgg'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY || 
    SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || 
    SUPABASE_ANON_KEY === '<ANON_KEY>') {
  console.error('Missing Supabase credentials');
  // Don't throw error here to allow the app to continue loading
}

console.log("Initializing Supabase client with URL:", SUPABASE_URL);
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;